import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';

import { TXTCLI_For_detailsX_see_Xa_hrefXXhttp_ELL } from './SeeDetailsLink.messages.json';

const SeeDetailsLink: React.FC = () => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();
  const { bonusUrl } = preCashinInfo as PreCashinInfo;
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);

  return (
    <Translation
      tagName="p"
      {...TXTCLI_For_detailsX_see_Xa_hrefXXhttp_ELL}
      values={{
        0: bonusUrl,
        a: (url: string) => (
          <StarsLink
            href={`${isMobileEmbedded ? 'external-' : ''}${url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {url}
          </StarsLink>
        )
      }}
    />
  );
};

export default SeeDetailsLink;
